/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var JobCategory;
(function (JobCategory) {
    let scheme;
    (function (scheme) {
        scheme["ROGUE_HIRE"] = "ROGUE_HIRE";
    })(scheme = JobCategory.scheme || (JobCategory.scheme = {}));
})(JobCategory || (JobCategory = {}));
